export function isError(value) {
    return typeof value === 'object' && value !== null && 'error' in value;
}
export function isValid(value) {
    return !isError(value);
}
//# sourceMappingURL=utils.js.map